<img
    alt="Grid"
    width="565"
    height="608"
    [ngSrc]="'grid' | asset: 'shared/grid'"
    class="grid"
    [class.hide-mobile]="hideMobile()"
    [class.hide-desktop]="hideDesktop()"
    [class.hide-tablet]="hideTablet()" />
